export default __webpack_public_path__ + "static/media/imgTemple.654da5b2.png";